import React, { ChangeEvent, ReactElement, useEffect, useState } from 'react';
import { Box, Button, TextField } from '@material-ui/core';
import { DialogWindow, DialogWindowHeader } from '..';

import './text-input-dialog.styles.scss';
import { useTranslation } from 'react-i18next';

export interface ITextInputDialogProps {
	title: string;
	label?: string;
	defaultValue?: string;
	placeholder?: string;
	open: boolean;
	cancelLabel?: string;
	confirmLabel?: string;
	onClose: () => void;
	onCancel: () => void;
	onConfirm: (value: string) => void;
}

export function TextInputDialog(props: ITextInputDialogProps): ReactElement {
	const {
		open,
		defaultValue,
		placeholder,
		title,
		label,
		cancelLabel,
		confirmLabel,
		onClose,
		onCancel,
		onConfirm
	} = props;

	const { t } = useTranslation('general');

	const [value, setValue] = useState<string>(defaultValue || '');

	useEffect(() => {
		if (defaultValue || (!defaultValue && value.length > 0)) {
			setValue(defaultValue || '');
		}
	}, [defaultValue]);

	function onValueChange(event: ChangeEvent<HTMLInputElement>): void {
		setValue(event.target.value);
	}

	function handleConfirm(): void {
		onConfirm(value);
	}

	return (
		<DialogWindow
			className="text-input-dialog"
			open={open}
			onClose={onClose}
		>
			<DialogWindowHeader title={title} onClose={onClose} />
			<Box className="text-input-dialog-input">
				<TextField
					label={label}
					value={value}
					placeholder={placeholder}
					onChange={onValueChange}
					variant="outlined"
					fullWidth
				/>
			</Box>
			<Box className="text-input-dialog-footer">
				<Button onClick={onCancel} color="primary">
					{cancelLabel || t('dialog.cancel')}
				</Button>
				<Button
					onClick={handleConfirm}
					disabled={value.length === 0}
					variant="contained"
					color="primary"
				>
					{confirmLabel || t('dialog.apply')}
				</Button>
			</Box>
		</DialogWindow>
	);
}
